module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--small@2x-8b6e04fb1b63e49a7d9d54b218ea150d.jpg";